import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  output,
} from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import { StatusChangeType } from '@recruitee/offers-data';
import { OfferStatus } from '@recruitee/offers-types';
import type { OfferSimpleListItem } from '@recruitee/offers-ui';
import { OfferStatusComponent } from '@recruitee/offers-ui';
import {
  ButtonComponent,
  ButtonDropdownIndicatorDirective,
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownHeaderComponent,
  DropdownItemComponent,
  DropdownWidth,
  OverlayOriginDirective,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-statuses-dropdown',
  templateUrl: './statuses-dropdown.component.html',
  styleUrls: ['./statuses-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownHeaderComponent,
    DropdownItemComponent,
    OfferStatusComponent,
    OverlayOriginDirective,
    TranslatePipe,
    ButtonDropdownIndicatorDirective,
    ButtonComponent,
  ],
})
export class StatusesDropdownComponent {
  @Input() public offer: OfferSimpleListItem;
  @Input() public state: 'read-only' | 'default' = 'default';
  @Input() public hasPublishActions = false;
  @Input() public isPlain = true;
  public action = output<StatusChangeType>();

  public StatusChangeType: typeof StatusChangeType = StatusChangeType;
  public OfferStatus: typeof OfferStatus = OfferStatus;
  public DropdownWidth = DropdownWidth;

  constructor(private cdRef: ChangeDetectorRef) {}

  public openStatusDropdown(dropdown: ConnectedOverlayDirective): void {
    if (this.state !== 'default') return;
    dropdown.open = !dropdown.open;
    this.cdRef.detectChanges();
  }

  public changeStatus(name: StatusChangeType): void {
    if (this.state !== 'default') return;
    this.action.emit(name);
  }
}
